import { LinkIcon } from 'lucide-react';

import { useIntegrations } from '@/entities/integrations';
import { SidebarDynamicMenuItem } from '@/shared/lib';

/**
 * Пункты динамического подменю активных интеграций под пунктом «Интеграции».
 *
 * Каждая активная интеграция отображается отдельным пунктом меню,
 * ведущим на /integrations/{code}.
 */
export const useIntegrationsMenuItems = (): SidebarDynamicMenuItem[] => {
  const { data } = useIntegrations({ isActive: true, limit: 100 });

  return (data?.items ?? []).map((integration) => ({
    key: integration.code,
    path: `/integrations/${integration.code}`,
    icon: <LinkIcon size={16} strokeWidth={1.25} className="text-muted-foreground" />,
    label: integration.name,
  }));
};
